<template>
<svg xmlns="http://www.w3.org/2000/svg" width="27.649" height="27.648" viewBox="0 0 27.649 27.648">
  <g id="Arrow_-_Right" data-name="Arrow - Right" transform="translate(0 1.061)">
    <line id="Line_1" data-name="Line 1" x2="25.527" transform="translate(0 12.764)" fill="none" :stroke="color" stroke-miterlimit="10" stroke-width="3"/>
    <path id="Path_48" data-name="Path 48" d="M560.5,8535.027l12.764-12.764L560.5,8509.5" transform="translate(-547.736 -8509.5)" fill="none" :stroke="color" stroke-miterlimit="10" stroke-width="3"/>
  </g>
</svg>

</template>
<script>
export default {
  name: 'SvgArrow',
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  }
}
</script>
<style lang="scss" scoped>
svg{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgArrow/SvgArrow.vue